import { render, staticRenderFns } from "./PendingTable.vue?vue&type=template&id=f6540e3e"
import script from "./PendingTable.vue?vue&type=script&lang=js"
export * from "./PendingTable.vue?vue&type=script&lang=js"
import style0 from "./PendingTable.vue?vue&type=style&index=0&id=f6540e3e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports